var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"round-button",on:{"click":function($event){return _vm.onClick()}}},[_c('i',{class:_vm.icon})])
}
var staticRenderFns = []

export { render, staticRenderFns }